import DataObjectField from '@/utilities/classes/data-object-field';

const buildLandlordBankInfoResubmissionDataObject = (vData)  => {

  const fields = [];

  if(vData.BankInfo.AccountNumber != null){
    fields.push(new DataObjectField(vData.BankInfo.AccountNumber, 8));
  }
  if(vData.BankInfo.RoutingNumber != null){
    fields.push(new DataObjectField(vData.BankInfo.RoutingNumber, 9));
  }
  if(vData.BankInfo.BankName != null){
    fields.push(new DataObjectField(vData.BankInfo.BankName, 142));
  }
  if(vData.BankInfo.NameOnBankAccount != null){
    fields.push(new DataObjectField(vData.BankInfo.NameOnBankAccount, 151));
  }
  if(vData.W9Info.W9EINNumber != null){
    fields.push(new DataObjectField(vData.W9Info.W9EINNumber, 166));
  }
  if(vData.W9Info.SSN != null){
    fields.push(new DataObjectField(vData.W9Info.SSN, 41));
  }
  if(vData.PropertyOwnerBusinessName != null){
    fields.push(new DataObjectField(vData.PropertyOwnerBusinessName, 152));
  }
  if(vData.W9Info.Address.Street1 != null){
    fields.push(new DataObjectField(vData.W9Info.Address.Street1, 154));
    fields.push(new DataObjectField(vData.W9Info.Address.Street2, 155));
    fields.push(new DataObjectField(vData.W9Info.Address.City, 156));
    fields.push(new DataObjectField(vData.W9Info.Address.State, 157));
    fields.push(new DataObjectField(vData.W9Info.Address.Zip, 158));
    fields.push(new DataObjectField(vData.W9Info.Address.Country, 159));
  }

  const dataObject = {
    qdbapi: {
      rid: vData.BankRecordId,
      udata : "EVICTION_DIVERSION_TFA_APPLICATION",
      clist: "32",
      field: fields,
    },
  };
  return dataObject;
};

export default buildLandlordBankInfoResubmissionDataObject;